/* External */
import { memo } from 'react';

/* Other */
import { getJsonImage } from 'src/theme/images';

/* Assets */
import LgLogo from '../../../assets/svg/lg-logo.svg?react';
import SamsungLogo from '../../../assets/svg/samsung-logo.svg?react';

/* Utils */
import platform from '../../../utils/platform';

function BrandLogo() {
  const lgBrandLogo = getJsonImage('lg-logo');
  const samsungLogo = getJsonImage('samsung-logo');

  if (platform.isWebOS) {
    return lgBrandLogo ? (
      <img
        src={lgBrandLogo}
        alt="Large Brand Logo"
        className="dtv-html5-c-brand-logo"
      />
    ) : (
      <LgLogo className="dtv-html5-c-brand-logo" />
    );
  }
  if (platform.isTizen) {
    return samsungLogo ? (
      <img
        src={samsungLogo}
        alt="Samsung Logo"
        className="dtv-html5-c-brand-logo"
      />
    ) : (
      <SamsungLogo className="dtv-html5-c-brand-logo" />
    );
  }
  // eslint-disable-next-line unicorn/no-null -- React does not support undefined
  return null;
}

export default memo(BrandLogo);
